import React, {useState, useEffect} from 'react';
import {runQuery} from '../utils'
import {getAuthorInformation} from './queries'


export interface MyComponentProps {
  authorid: string
  handleChangeInfo: any
  // Define your prop types here
}
export const AuthorCollection: React.FC<MyComponentProps> = (props) => {
  const [authorTitle, setAuthorTitle] = useState<string>("")
  const [authorArticles, setAuthorArticles] = useState<any[]>([])
  const [textArticles, setTextArticles] = useState<any[]>([])
  const [expressions, setExpressions] = useState<any[]>([])
  const [itemFilter, setItemFilter] = useState<string>("")

  useEffect(() => {
    retrieveAuthorCollectionInfo()
  }, [props.authorid]);
  
  const retrieveAuthorCollectionInfo = () => {
    const resourceid = props.authorid
    runQuery(getAuthorInformation(resourceid)).then((d) => {
      // I'm getting super weird behavior with the fuseki construct query response
      // the way the prefixes are being returned is not consistent
      // so i'm going to stringify the response, and convert all the variations to full the url
      let responseData = JSON.stringify(d.data);
      responseData = responseData.replace(/scta:resource\//g, 'http://scta.info/resource/');
      responseData = responseData.replace(/scta:property\//g, 'http://scta.info/property/');
      responseData = responseData.replace(/sctap:/g, 'http://scta.info/property/');
      responseData = responseData.replace(/sctar:/g, 'http://scta.info/resource/');
      responseData = responseData.replace(/j.0:/g, 'http://scta.info/property/');
      responseData = JSON.parse(responseData);
      
      // author get with conditional fall back due to strange changing behavior in results
      let author = responseData["@graph"].filter((i) => i["@id"] === resourceid)[0]
      // if (!author){
      //   author = d.data["@graph"].filter((i) => i["@id"] === resourceid)[0]
      // }
      const authorTitle = author["dc:title"]
      
      let authorArticles = null
      if(Array.isArray(author["http://scta.info/property/authorArticle"])){
        authorArticles =  author["http://scta.info/property/authorArticle"].map((a) => {
          return {
            id: a["@id"],
            //change due to fuseki 4.3.1 update 
            //title: d.data["@graph"].filter((i) => i["@id"] === a)[0]["http://purl.org/dc/elements/1.1/title"]
            title: responseData["@graph"].filter((i) => i["@id"] === a["@id"])[0]["dc:title"]
          }
        })
      }
      else if (author["http://scta.info/property/authorArticle"]){
        authorArticles = [{id: author["http://scta.info/property/authorArticle"]["@id"], title: responseData["@graph"].filter((i) => i["@id"] === author["http://scta.info/property/authorArticle"]["@id"])[0]["dc:title"]}]
      }
      let textArticles = null
      if(Array.isArray(author["http://scta.info/property/textArticle"])){
          textArticles =  author["http://scta.info/property/textArticle"].map((a) => {
          return {
            id: a["@id"],
            title: responseData["@graph"].filter((i) => i["@id"] === a["@id"])[0]["dc:title"]
          }
        })
      }
      else if (author["http://scta.info/property/textArticle"]){
        textArticles = [{id: author["http://scta.info/property/textArticle"]["@id"], title: responseData["@graph"].filter((i) => i["@id"] === author["http://scta.info/property/textArticle"]["@id"])[0]["dc:title"]}]
      }

      let expressions = null
      if(Array.isArray(author["http://scta.info/property/hasTopLevelExpression"])){
        expressions =  author["http://scta.info/property/hasTopLevelExpression"].map((a) => {
          return {
            id: a["@id"],
            title: responseData["@graph"].filter((i) => i["@id"] === a["@id"])[0]["dc:title"]
          }
        })
      }
      else if (author["http://scta.info/property/hasTopLevelExpression"]){
        expressions = [{id: author["http://scta.info/property/hasTopLevelExpression"]["@id"], title: responseData["@graph"].filter((i) => i["@id"] === author["http://scta.info/property/hasTopLevelExpression"]["@id"])[0]["dc:title"]}]
      }
      setAuthorTitle(authorTitle)
      expressions.sort((a: any, b: any) => a.title.localeCompare(b.title))
      setExpressions(expressions)
      setTextArticles(textArticles)
      setAuthorArticles(authorArticles)
      
      
    })
    .catch((err) => {
      console.log(err)
    })
  }

  const displayItems = (list: any[]) => {
    const items = list.map((i) => {
      return (

        <p key={i.id}>
          {props.handleChangeInfo ?
          <span className="lbp-span-link" onClick={() => {props.handleChangeInfo(i.id)}}>
            {i.title}
          </span>
          : 
          <>{i.title}</>}
          </p>

      )
    });
    return items
  }

  
  return (
    
      <div>
      <h1>{authorTitle}</h1>
        {expressions &&
        <div>
        <h1>Expressions</h1>
        {displayItems(expressions)}
        </div>
      }
      {authorArticles &&
        <div>
        <h1>Author Related Articles</h1>
        <div>
        {displayItems(authorArticles)}
        </div>
      </div>
      }
      {textArticles &&
        <div>
        <h1>Text Related Articles</h1>
        <div>
        {displayItems(textArticles)}
        </div>
        </div>
      }
      </div>
    );
  }